﻿// Уведомления для форм
class FormNotifications {
    constructor() {
        this.activeNotifications = new Map();
        this.init();
    }

    init() {
        // Контейнер не нужен, уведомления будут добавляться в разные места
    }

    show(message, type = 'success', duration = 5000, formElement = null) {
        const id = Date.now() + Math.random();

        // Создаем уведомление
        const notification = document.createElement('div');
        notification.className = `form-notification form-notification--${type}`;

        // Содержимое
        const content = document.createElement('div');
        content.className = 'form-notification__content';

        const iconContainer = document.createElement('div');
        iconContainer.className = 'form-notification__icon';
        const icon = document.createElement('i');
        icon.className = `fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}`;
        iconContainer.appendChild(icon);
        content.appendChild(iconContainer);

        const textEl = document.createElement('div');
        textEl.className = 'form-notification__text';
        textEl.textContent = message;
        content.appendChild(textEl);

        notification.appendChild(content);

        // Кнопка закрытия
        const closeBtn = document.createElement('button');
        closeBtn.className = 'form-notification__close';
        closeBtn.addEventListener('click', () => this.hide(id));
        const closeIcon = document.createElement('i');
        closeIcon.className = 'fas fa-times';
        closeBtn.appendChild(closeIcon);
        notification.appendChild(closeBtn);

        let container;
        
        // Ошибки - в правый верхний угол (fixed)
        if (type === 'error') {
            container = document.body;
        } 
        // Успехи - под форму
        else if (formElement) {
            // Если есть форма, оборачиваем ее в контейнер
            if (!formElement.parentElement.classList.contains('form-container')) {
                const formContainer = document.createElement('div');
                formContainer.className = 'form-container';
                formElement.parentNode.insertBefore(formContainer, formElement);
                formContainer.appendChild(formElement);
                container = formContainer;
            } else {
                container = formElement.parentElement;
            }
            
            // Добавляем класс для контейнера с уведомлением
            if (container.classList.contains('form-container')) {
                container.classList.add('has-notification');
            }
        } else {
            // Если форма не найдена, добавляем в конец body
            container = document.body;
        }
        
        container.appendChild(notification);
        this.activeNotifications.set(id, { element: notification, container: container, type: type });

        // Показываем с анимацией
        requestAnimationFrame(() => {
            notification.classList.add('show');
        });

        // Автоматически скрываем через указанное время
        if (duration > 0) {
            setTimeout(() => {
                this.hide(id);
            }, duration);
        }

        return id;
    }

    hide(id) {
        const notificationData = this.activeNotifications.get(id);
        if (!notificationData) return;

        const { element: notification, container, type } = notificationData;

        // Добавляем класс для анимации исчезновения
        notification.classList.add('hiding');

        // Удаляем после анимации
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
            
            // Убираем класс с контейнера если больше нет уведомлений (только для успехов)
            if (type === 'success' && container && container.classList.contains('form-container')) {
                const remainingNotifications = container.querySelectorAll('.form-notification--success:not(.hiding)');
                if (remainingNotifications.length === 0) {
                    container.classList.remove('has-notification');
                }
            }
            
            this.activeNotifications.delete(id);
        }, type === 'error' ? 300 : 400); // Ошибки скрываются быстрее
    }

    hideAll() {
        this.activeNotifications.forEach((notificationData, id) => {
            this.hide(id);
        });
    }

    success(message, duration = 5000, formElement = null) {
        return this.show(message, 'success', duration, formElement);
    }

    error(message, duration = 8000, formElement = null) {
        return this.show(message, 'error', duration, formElement);
    }
}

// Глобальный экземпляр
const formNotifications = new FormNotifications();

// Экспортируем для глобального доступа
window.formNotifications = formNotifications;

